import { memo } from 'react'
import Rive, { type RiveProps } from '@rive-app/react-canvas'
import loaderUrl from '/public/static/gg_loader.riv?no-inline'

const LoadingAnimation = (props: Omit<RiveProps, 'src' | 'stateMachines'>) => (
  <Rive
    style={{
      maxWidth: '480px',
      maxHeight: '480px',
      width: '200px',
      height: '200px',
      margin: '20px'
    }}
    {...props}
    src={loaderUrl}
    stateMachines="greenLoaderSM"
  />
)

export default memo(LoadingAnimation)
